///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'sui-svg-icon[windeOrange]',
    standalone: false
})
export class OrangeActionIconDirective {
    @HostBinding('class') buttonClass = 'winde-svg-action-icon winde-orange-icon';

    @HostBinding('style.width') width = '1em';
    @HostBinding('style.height') height = '1em';
}
